import MaintenanceUnderConstruction from "features/maintenance/pages/MaintenanceUnderConstruction";
import RequirePermission from "routes/RequirePermission";

export function flattenMenuRoutes(menuItems = []) {
    return menuItems.reduce((routes, item) => {
        if (item.path && !item.children?.length) {
            routes.push({
                path: item.path,
                element: (
                    <RequirePermission
                        requiredPermissions={item.requiredPermissions}
                    >
                        {item.element ?? <MaintenanceUnderConstruction />}
                    </RequirePermission>
                )
            });
        }
        if (item.children?.length) {
            routes.push(...flattenMenuRoutes(item.children));
        }
        return routes;
    }, []);
}
